import { createSlice } from '@reduxjs/toolkit';
import { TASK_STATUS } from '../../constants/activityCenter';
import { isCompletedStatus } from '../../components/ui/ActivityCenterTasks/utils/activityCenter';

const initialState = {
  tasks: [],
  isConnected: false,
  lastUpdated: null,
};

const activityCenterSlice = createSlice({
  name: 'activityCenter',
  initialState,
  reducers: {
    addTask(state, action) {
      const task = {
        ...action.payload,
        id: action.payload.id || Date.now().toString(),
        createdAt: action.payload.createdAt || new Date().toISOString(),
        status: action.payload.status || TASK_STATUS.QUEUED,
      };
      state.tasks.unshift(task);
      state.lastUpdated = new Date().toISOString();
    },

    updateTaskStatus(state, action) {
      const { id, status, progress, error, result } = action.payload;
      const taskIndex = state.tasks.findIndex((task) => task.id === id);

      if (taskIndex !== -1) {
        state.tasks[taskIndex].status = status;
        if (progress !== undefined) state.tasks[taskIndex].progress = progress;
        if (error) state.tasks[taskIndex].error = error;
        if (result) state.tasks[taskIndex].result = result;
        if (status === TASK_STATUS.COMPLETED || status === TASK_STATUS.FAILED) {
          state.tasks[taskIndex].completedAt = new Date().toISOString();
        }
        state.lastUpdated = new Date().toISOString();
      }
    },

    completeTask(state, action) {
      const { id, result } = action.payload;
      const taskIndex = state.tasks.findIndex((task) => task.id === id);

      if (taskIndex !== -1) {
        state.tasks[taskIndex].status = TASK_STATUS.COMPLETED;
        state.tasks[taskIndex].result = result;
        state.tasks[taskIndex].completedAt = new Date().toISOString();
        state.lastUpdated = new Date().toISOString();
      }
    },

    failTask(state, action) {
      const { id, error } = action.payload;
      const taskIndex = state.tasks.findIndex((task) => task.id === id);

      if (taskIndex !== -1) {
        state.tasks[taskIndex].status = TASK_STATUS.FAILED;
        state.tasks[taskIndex].error = error;
        state.tasks[taskIndex].completedAt = new Date().toISOString();
        state.lastUpdated = new Date().toISOString();
      }
    },

    clearCompletedTasks(state) {
      state.tasks = state.tasks.filter((task) => !isCompletedStatus(task.status));
      state.lastUpdated = new Date().toISOString();
    },

    clearTask(state, action) {
      const taskId = action.payload;
      state.tasks = state.tasks.filter((task) => task.id !== taskId);
      state.lastUpdated = new Date().toISOString();
    },

    clearAllTasks(state) {
      state.tasks = [];
      state.lastUpdated = new Date().toISOString();
    },

    setConnectionStatus(state, action) {
      state.isConnected = action.payload;
    },
  },
});

export const activityCenterActions = activityCenterSlice.actions;

export default activityCenterSlice.reducer;
